/**
 * @generated SignedSource<<bd8811f643bfba79c3ac5725f124bd41>>
 * @relayHash ee7ea1fc83196e980e0ddd46f253c0e5
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID ee7ea1fc83196e980e0ddd46f253c0e5

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ccnId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siret"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v3 = [
  {
    "kind": "Variable",
    "name": "ccnId",
    "variableName": "ccnId"
  },
  {
    "kind": "Literal",
    "name": "isHealthAmendment",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "siret",
    "variableName": "siret"
  },
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ContractHealth",
  "kind": "LinkedField",
  "name": "health",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Amendment",
      "kind": "LinkedField",
      "name": "amendment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAmendment",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AmendmentHealthQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Proposition",
        "kind": "LinkedField",
        "name": "propositionInfo",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AmendmentHealthQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Proposition",
        "kind": "LinkedField",
        "name": "propositionInfo",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ee7ea1fc83196e980e0ddd46f253c0e5",
    "metadata": {},
    "name": "AmendmentHealthQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "d4cd6c8575852ad81e81d3361f04a083";

export default node;
